import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const CONFLICT_ROUTE = {
    typeModal: TYPE_MODAL.NOTIFICATION,
    title: '¿Está seguro de haber resuelto todo los conflictos?',
    valueButton: 'Guardar',
    color: CONFIRM_COLOR.SUCCESS,
    iconSVG: CONFIRM_ICONS.SAVE
  };
